import React from 'react';
import LeadQuestionnaire from '../LeadQuestionnaire';
import { coachImages } from '../../data/mock';

const HeroSection = () => {
  return (
    <section id="hero" className="relative min-h-screen overflow-hidden">
      {/* Full-Screen Background Image - Zoomed in on mobile to show physique */}
      <div className="absolute inset-0">
        <img 
          src={coachImages.hero} 
          alt="Dallas Keller" 
          className="w-full h-full object-cover scale-150 object-[center_30%] sm:scale-100 sm:object-[center_25%]"
        />
        {/* Dark Overlay - lighter to show more of the image */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/30 to-black/75 sm:from-black/20 sm:via-black/40 sm:to-black/80" />
      </div>

      {/* Content Container */}
      <div className="relative z-10 min-h-screen flex flex-col px-3 sm:px-4">
        {/* Top Branding */}
        <div className="pt-4 sm:pt-6 text-center">
          <div className="inline-flex items-center gap-2 bg-black/50 backdrop-blur-md border border-white/30 px-4 py-2">
            <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
            <span className="text-xs sm:text-sm font-bold text-white uppercase tracking-widest">Now Accepting Clients</span>
          </div>
        </div>

        {/* Spacer to push form down on mobile - increased to show more physique */}
        <div className="flex-grow-0 h-80 sm:h-0" />

        {/* Main Form Area */}
        <div className="flex-1 flex items-start sm:items-center justify-center pb-2 sm:py-4">
          <div className="w-full max-w-md">
            <LeadQuestionnaire />
          </div>
        </div>

        {/* Bottom Reassurance */}
        <div className="pb-4 sm:pb-6 text-center">
          <p className="text-white/50 text-xs sm:text-sm max-w-xs mx-auto leading-relaxed">
            No spam. No pressure.<br className="sm:hidden" /> If we're not a fit, we'll tell you.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
